// Curated list of 60+ beautiful Google Fonts with Bangla and English support
export const GOOGLE_FONTS = [
  // === BANGLA SUPPORT FONTS (6) ===
  { name: 'Noto Serif Bengali', value: "'Noto Serif Bengali', serif", category: 'serif', bangla: true },
  { name: 'Noto Sans Bengali', value: "'Noto Sans Bengali', sans-serif", category: 'sans-serif', bangla: true },
  { name: 'Hind Siliguri', value: "'Hind Siliguri', sans-serif", category: 'sans-serif', bangla: true },
  { name: 'Tiro Bangla', value: "'Tiro Bangla', serif", category: 'serif', bangla: true },
  { name: 'Mukta', value: "'Mukta', sans-serif", category: 'sans-serif', bangla: true },
  { name: 'Baloo Da 2', value: "'Baloo Da 2', cursive", category: 'display', bangla: true },
  
  // === SERIF FONTS - Elegant & Traditional (20) ===
  { name: 'Playfair Display', value: "'Playfair Display', serif", category: 'serif', bangla: false },
  { name: 'Merriweather', value: "'Merriweather', serif", category: 'serif', bangla: false },
  { name: 'Crimson Text', value: "'Crimson Text', serif", category: 'serif', bangla: false },
  { name: 'Libre Baskerville', value: "'Libre Baskerville', serif", category: 'serif', bangla: false },
  { name: 'Old Standard TT', value: "'Old Standard TT', serif", category: 'serif', bangla: false },
  { name: 'Cormorant Garamond', value: "'Cormorant Garamond', serif", category: 'serif', bangla: false },
  { name: 'EB Garamond', value: "'EB Garamond', serif", category: 'serif', bangla: false },
  { name: 'Lora', value: "'Lora', serif", category: 'serif', bangla: false },
  { name: 'Cinzel', value: "'Cinzel', serif", category: 'serif', bangla: false },
  { name: 'Spectral', value: "'Spectral', serif", category: 'serif', bangla: false },
  { name: 'PT Serif', value: "'PT Serif', serif", category: 'serif', bangla: false },
  { name: 'Georgia', value: 'Georgia, serif', category: 'serif', bangla: false },
  { name: 'Bitter', value: "'Bitter', serif", category: 'serif', bangla: false },
  { name: 'Cardo', value: "'Cardo', serif", category: 'serif', bangla: false },
  { name: 'Vollkorn', value: "'Vollkorn', serif", category: 'serif', bangla: false },
  { name: 'Alegreya', value: "'Alegreya', serif", category: 'serif', bangla: false },
  { name: 'Crimson Pro', value: "'Crimson Pro', serif", category: 'serif', bangla: false },
  { name: 'Literata', value: "'Literata', serif", category: 'serif', bangla: false },
  { name: 'Source Serif Pro', value: "'Source Serif Pro', serif", category: 'serif', bangla: false },
  { name: 'Zilla Slab', value: "'Zilla Slab', serif", category: 'serif', bangla: false },
  
  // === SANS-SERIF FONTS - Modern & Clean (20) ===
  { name: 'Roboto', value: "'Roboto', sans-serif", category: 'sans-serif', bangla: false },
  { name: 'Open Sans', value: "'Open Sans', sans-serif", category: 'sans-serif', bangla: false },
  { name: 'Lato', value: "'Lato', sans-serif", category: 'sans-serif', bangla: false },
  { name: 'Montserrat', value: "'Montserrat', sans-serif", category: 'sans-serif', bangla: false },
  { name: 'Raleway', value: "'Raleway', sans-serif", category: 'sans-serif', bangla: false },
  { name: 'Poppins', value: "'Poppins', sans-serif", category: 'sans-serif', bangla: false },
  { name: 'Inter', value: "'Inter', sans-serif", category: 'sans-serif', bangla: false },
  { name: 'Work Sans', value: "'Work Sans', sans-serif", category: 'sans-serif', bangla: false },
  { name: 'Nunito', value: "'Nunito', sans-serif", category: 'sans-serif', bangla: false },
  { name: 'Rubik', value: "'Rubik', sans-serif", category: 'sans-serif', bangla: false },
  { name: 'Karla', value: "'Karla', sans-serif", category: 'sans-serif', bangla: false },
  { name: 'Quicksand', value: "'Quicksand', sans-serif", category: 'sans-serif', bangla: false },
  { name: 'Josefin Sans', value: "'Josefin Sans', sans-serif", category: 'sans-serif', bangla: false },
  { name: 'Barlow', value: "'Barlow', sans-serif", category: 'sans-serif', bangla: false },
  { name: 'DM Sans', value: "'DM Sans', sans-serif", category: 'sans-serif', bangla: false },
  { name: 'Manrope', value: "'Manrope', sans-serif", category: 'sans-serif', bangla: false },
  { name: 'Outfit', value: "'Outfit', sans-serif", category: 'sans-serif', bangla: false },
  { name: 'Space Grotesk', value: "'Space Grotesk', sans-serif", category: 'sans-serif', bangla: false },
  { name: 'Plus Jakarta Sans', value: "'Plus Jakarta Sans', sans-serif", category: 'sans-serif', bangla: false },
  { name: 'Lexend', value: "'Lexend', sans-serif", category: 'sans-serif', bangla: false },
  
  // === DISPLAY FONTS - Bold & Decorative (15) ===
  { name: 'Bebas Neue', value: "'Bebas Neue', cursive", category: 'display', bangla: false },
  { name: 'Oswald', value: "'Oswald', sans-serif", category: 'display', bangla: false },
  { name: 'Abril Fatface', value: "'Abril Fatface', cursive", category: 'display', bangla: false },
  { name: 'Righteous', value: "'Righteous', cursive", category: 'display', bangla: false },
  { name: 'Lobster', value: "'Lobster', cursive", category: 'display', bangla: false },
  { name: 'Pacifico', value: "'Pacifico', cursive", category: 'display', bangla: false },
  { name: 'Anton', value: "'Anton', sans-serif", category: 'display', bangla: false },
  { name: 'Archivo Black', value: "'Archivo Black', sans-serif", category: 'display', bangla: false },
  { name: 'Bungee', value: "'Bungee', cursive", category: 'display', bangla: false },
  { name: 'Fredoka One', value: "'Fredoka One', cursive", category: 'display', bangla: false },
  { name: 'Permanent Marker', value: "'Permanent Marker', cursive", category: 'display', bangla: false },
  { name: 'Alfa Slab One', value: "'Alfa Slab One', cursive", category: 'display', bangla: false },
  { name: 'Bangers', value: "'Bangers', cursive", category: 'display', bangla: false },
  { name: 'Righteous', value: "'Righteous', cursive", category: 'display', bangla: false },
  { name: 'Shadows Into Light', value: "'Shadows Into Light', cursive", category: 'display', bangla: false },
  
  // === CERTIFICATE & FORMAL FONTS - Elegant & Prestigious (12) ===
  { name: 'Great Vibes', value: "'Great Vibes', cursive", category: 'certificate', bangla: false },
  { name: 'Tangerine', value: "'Tangerine', cursive", category: 'certificate', bangla: false },
  { name: 'Dancing Script', value: "'Dancing Script', cursive", category: 'certificate', bangla: false },
  { name: 'Satisfy', value: "'Satisfy', cursive", category: 'certificate', bangla: false },
  { name: 'Allura', value: "'Allura', cursive", category: 'certificate', bangla: false },
  { name: 'Pinyon Script', value: "'Pinyon Script', cursive", category: 'certificate', bangla: false },
  { name: 'Alex Brush', value: "'Alex Brush', cursive", category: 'certificate', bangla: false },
  { name: 'Italianno', value: "'Italianno', cursive", category: 'certificate', bangla: false },
  { name: 'Kaushan Script', value: "'Kaushan Script', cursive", category: 'certificate', bangla: false },
  { name: 'Parisienne', value: "'Parisienne', cursive", category: 'certificate', bangla: false },
  { name: 'Sacramento', value: "'Sacramento', cursive", category: 'certificate', bangla: false },
  { name: 'Yellowtail', value: "'Yellowtail', cursive", category: 'certificate', bangla: false },
];

// Load Google Font dynamically
export const loadGoogleFont = (fontName) => {
  const font = GOOGLE_FONTS.find(f => f.name === fontName);
  if (!font) return;

  // Check if font is already loaded
  const existingLink = document.querySelector(`link[data-font="${fontName}"]`);
  if (existingLink) return;

  // Create link element
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = `https://fonts.googleapis.com/css2?family=${fontName.replace(/ /g, '+')}:wght@300;400;500;600;700&display=swap`;
  link.setAttribute('data-font', fontName);
  document.head.appendChild(link);
};

// Load all Google Fonts at once (for admin panel)
export const loadAllGoogleFonts = () => {
  const fontFamilies = GOOGLE_FONTS
    .map(f => f.name.replace(/ /g, '+'))
    .join('&family=');
  
  const existingLink = document.querySelector('link[data-font="all-google-fonts"]');
  if (existingLink) return;

  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = `https://fonts.googleapis.com/css2?${fontFamilies.split('&family=').map(f => `family=${f}:wght@300;400;500;600;700`).join('&')}&display=swap`;
  link.setAttribute('data-font', 'all-google-fonts');
  document.head.appendChild(link);
};
